import type { Entity } from '@backstage/catalog-model';
import type { ComponentType } from 'react';

import {
  coreExtensionData,
  createExtensionBlueprint,
  createExtensionDataRef,
  ExtensionBoundary,
} from '@backstage/frontend-plugin-api';

const toolbarElementComponent = createExtensionDataRef<
  ComponentType<{ entity: Entity }>
>().with({
  id: 'ipen.entity-toolbar-element.component',
});

const toolbarElementFilterFunction = createExtensionDataRef<
  (entity: Entity) => boolean
>().with({
  id: 'ipen.entity-toolbar-element.filter-function',
});

export const EntityToolbarElementBlueprint = createExtensionBlueprint({
  attachTo: {
    id: 'entity-layout:catalog/ipen-layout',
    input: 'toolbarElements',
  },
  dataRefs: {
    component: toolbarElementComponent,
    filterFunction: toolbarElementFilterFunction,
  },
  * factory(
    params: {
      component: () => Promise<(props: { entity: Entity }) => JSX.Element>;
      filter?: (entity: Entity) => boolean;
      path: string;
    },
    { node },
  ) {
    yield coreExtensionData.routePath(params.path);
    if (params.filter) {
      yield toolbarElementFilterFunction(params.filter);
    }
    yield toolbarElementComponent(
      ExtensionBoundary.lazyComponent(node, params.component),
    );
  },
  kind: 'entity-toolbar-element',
  output: [
    toolbarElementComponent,
    toolbarElementFilterFunction.optional(),
    coreExtensionData.routePath,
  ],
});
